/**
 * paidDownloads — client-side memory of which recipe slugs the current
 * browser has purchased. Persisted in localStorage so a reader who bought
 * a recipe last week can still re-download it today.
 *
 * Storage shape: `{ [slug]: session_id }` under the single key `bb_paid`.
 * We keep the session_id (not just a boolean) so the download endpoint
 * can revalidate against Stripe/DB, closing off "flip the flag in DevTools"
 * bypasses.
 */
const KEY = "bb_paid";

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function markPaid(slug, sessionId) {
  if (!slug || !sessionId) return;
  const all = readAll();
  all[slug] = sessionId;
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch {}
}

export function getPaidSession(slug) {
  return readAll()[slug] || null;
}

export function isPaid(slug) {
  return !!getPaidSession(slug);
}
